import { SxProps, Theme } from '@mui/material';
import { Colors } from '../../../constants';

export const coreTimePickerStyles: SxProps<Theme> = {
	'&.MuiPickersLayout-root': {
		backgroundColor: Colors.black_a20,
		backdropFilter: 'blur(20px)',
		transitionDuration: '0.5s',
		transitionProperty: 'opacity',
	},

	'& .MuiPickersToolbar-root': {
		backgroundColor: Colors.transparent,

		'&.MuiButton-root': {
			backgroundColor: Colors.transparent,
		},

		'& .MuiTypography-overline': {
			display: 'none',
		},

		'& .MuiTypography-root': {
			color: Colors.white,
			fontFamily: 'Integral CF, sans-serif',
		},

		'& .MuiTimePickerToolbar-ampmSelection': {
			height: '100%',

			'& .MuiTypography-root': {
				opacity: 0.45,

				"&.Mui-selected": {
					opacity: 1
				}
			},
		}
	},

	'& .MuiTimeClock-root': {
		backgroundColor: Colors['070605'],

		'& .MuiPickersArrowSwitcher-root': {
			display: 'none',
		}
	},

	'& .MuiClock-root': {
		m: '40px 20px',

		'& .MuiClock-pin': {
			backgroundColor: Colors.white,
		},

		'& .MuiClockPointer-root': {
			backgroundColor: Colors.white,

			'& .MuiClockPointer-thumb': {
				backgroundColor: Colors.white,
				borderColor: Colors.white,
			}
		}
	},
};
